import { component } from "picoapp";

export const select = component((node: HTMLElement) => {
  const button = node.querySelector<HTMLButtonElement>("button");
  const fieldsetElement = node.querySelector<HTMLElement>("[data-fieldset]");
  const options = node.querySelectorAll<HTMLElement>(".select-options li");
  const sectionId = node.dataset.id;
  const hiddenField = node.querySelector<HTMLInputElement>(
    "#" + sectionId + "-hidden-field"
  );
  const selectedValue = node.querySelector<HTMLButtonElement>(
    "#" + sectionId + "-selected-value"
  );
  let isExpanded = false;

  node.addEventListener("click", handleButtonClick);
  node.addEventListener("keydown", handleButtonKeypresses);
  document.addEventListener("click", handleBodyClick);

  options.forEach(function (option) {
    option.addEventListener("click", (e) => {
      e.stopPropagation();
      const target = (e.target as HTMLElement).closest("li");
      selectOption(target);
      collapseOptions();
    });
  });

  function handleBodyClick(e) {
    if (!node.contains(e.target) && isExpanded) {
      collapseOptions();
    }
  }

  function handleButtonClick() {
    if (isExpanded) {
      collapseOptions();
    } else {
      expandOptions();
    }
  }

  function collapseOptions() {
    button.setAttribute("aria-expanded", "false");
    button.classList.remove("tw-hidden");
    fieldsetElement.classList.add("tw-hidden");
    isExpanded = false;
    button.focus();
  }

  function expandOptions() {
    button.setAttribute("aria-expanded", "true");
    fieldsetElement.classList.remove("tw-hidden");
    isExpanded = true;
  }

  function selectOption(option) {
    unselectAllOptions();
    option.setAttribute("aria-selected", true);
    button.setAttribute("aria-activedescendant", option.getAttribute("id"));
    hiddenField.value = option.textContent;
    selectedValue.innerHTML = option.textContent;
  }

  function unselectAllOptions() {
    options.forEach(function (option) {
      option.removeAttribute("aria-selected");
    });
  }

  function handleButtonKeypresses(e) {
    switch (e.key) {
      case "ArrowUp":
        e.preventDefault();

        if (isExpanded) {
          selectPreviousOption();
        } else {
          expandOptions();
        }

        break;

      case "ArrowDown":
        e.preventDefault();

        if (isExpanded) {
          selectNextOption();
        } else {
          expandOptions();
          selectFirstOption();
        }

        break;

      case "Home":
        if (isExpanded) {
          selectFirstOption();
        }

        break;

      case "End":
        if (isExpanded) {
          selectLastOption();
        }

        break;

      case "Tab":
        collapseOptions();
        break;

      case "Escape":
      case "Enter":
        if (isExpanded) {
          e.preventDefault();
          collapseOptions();
        }

        break;
    }
  }

  function selectFirstOption() {
    const firstOption = options[0];
    selectOption(firstOption);
  }

  function selectLastOption() {
    const lastOption = options[options.length - 1];
    selectOption(lastOption);
  }

  function selectNextOption() {
    const currentOption = document.getElementById(
      button.getAttribute("aria-activedescendant")
    );

    if (currentOption !== undefined) {
      const currentOptionIndex = [...options].indexOf(currentOption);

      if (currentOptionIndex + 1 < options.length) {
        const nextOption = options[currentOptionIndex + 1];
        selectOption(nextOption);
      }
    }
  }

  function selectPreviousOption() {
    const currentOption = document.getElementById(
      button.getAttribute("aria-activedescendant")
    );

    if (currentOption) {
      const currentOptionIndex = [...options].indexOf(currentOption);

      if (currentOptionIndex - 1 >= 0) {
        const previousOption = options[currentOptionIndex - 1];
        selectOption(previousOption);
      }
    }
  }

  return () => {
    node.removeEventListener("click", handleButtonClick);
    document.removeEventListener("click", handleBodyClick);
  };
});
